import React, { useEffect, useState } from "react";
import { Table, Alert } from "react-bootstrap";
import EnrollmentService from "../../../_services/EnrollmentService";
import CollapsibleSection from "./CollapsibleSection";

interface StatusHistorySectionProps {
  enrollmentId: number;
}

const StatusHistorySection: React.FC<StatusHistorySectionProps> = ({ enrollmentId }) => {
  const [history, setHistory] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setError(null);
    EnrollmentService.getStatusHistory(enrollmentId)
      .then((res: any) => {
        if (res.data?.success) setHistory(res.data.data.history || []);
        else setError(res.data?.message || "Failed to load status history");
      })
      .catch((err: any) =>
        setError(
          err.response?.data?.message ||
            err.message ||
            "Failed to load status history",
        ),
      )
      .finally(() => setLoading(false));
  }, [enrollmentId]);

  return (
    <CollapsibleSection title="Status History" count={history.length} defaultOpen={false}>
      {loading ? (
        <div className="ev-loading"><i className="fa fa-spinner fa-spin" /> Loading...</div>
      ) : error ? (
        <Alert variant="danger" style={{ fontSize: 12, marginBottom: 0 }}>
          {error}
        </Alert>
      ) : history.length === 0 ? (
        <div className="ev-empty">No status history</div>
      ) : (
        <Table bordered hover size="sm" style={{ fontSize: 12, marginBottom: 0 }}>
          <thead>
            <tr>
              <th>From</th>
              <th>To</th>
              <th>Changed By</th>
              <th>Date</th>
              <th>Reason</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {history.map((h: any) => (
              <tr key={h.id}>
                <td>{h.previousStatusName}</td>
                <td style={{ fontWeight: 600 }}>{h.newStatusName}</td>
                <td>{h.changedByUserName}</td>
                <td>{h.changedDate}</td>
                <td>{h.reason}</td>
                <td>{h.remarks}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </CollapsibleSection>
  );
};

export default StatusHistorySection;
